module.exports = __webpack_public_path__ + "img/logo-B1fkTwuY.fff6f000.jpg";